import { render, staticRenderFns } from "./NewUserCard.vue?vue&type=template&id=3d5eaf8d&scoped=true&"
import script from "./NewUserCard.vue?vue&type=script&lang=js&"
export * from "./NewUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5eaf8d",
  null
  
)

export default component.exports